import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { Repo } from '../../repo.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { GlobalEmailTemplateMetadata } from '@models/global-email-templates';

@Injectable({
	providedIn: 'root',
})
export class BusinessEmailTemplatesRepo extends Repo<
	GlobalEmailTemplateMetadata,
	null
> {
	@SelectSnapshot(BusinessState.businessId) businessId: string;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(): string {
		return CollectionPaths.business_email_templates(this.businessId);
	}
}
